import React, { FunctionComponent, ReactNode, useEffect } from 'react';
import ErrorBoundary from 'pages/App/ErrorBoundary/index';
import useAccount from 'hooks/useAccount';
import useProfile from 'hooks/useProfile';
import { setSentryUser, setSentryContext } from 'libs/sentry';

const ErrorBoundaryWrapper: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const { account } = useAccount();
  const { profile } = useProfile();

  useEffect(() => {
    setSentryContext('account', account?.id ? { id: account.id.toString() } : null);
  }, [account]);

  useEffect(() => {
    setSentryUser(profile?.id ? { id: profile.id.toString() } : null);
  }, [profile]);

  return <ErrorBoundary>{children}</ErrorBoundary>;
};

export default ErrorBoundaryWrapper;
